import Icon from '@/components/snippets/icon/icon'
import { useAccountLayoutContext } from '@/components/libs/omneo/components/AccountProfileContext'
import { useMemo } from 'preact/hooks'
import { AssignShoesModal } from './AssignShoesModal'
import { accountTranslations } from '../helpers/translations'

const AccountChecklistCompleteButton = ({ callback, complete }) => {
  return (
    <div
      onClick={() => {
        if (complete) return
        callback()
      }}
      className={`flex flex-row items-center gap-2 rounded-full border border-solid border-black p-2 md:rounded-3xl md:px-4 ${
        complete ? ' border-primary-blue bg-primary-blue text-primary-white' : 'cursor-pointer'
      }`}
    >
      <Icon id={complete ? 'tick' : 'plus'} />
      <div className={'paragraph-sm hidden md:flex'}>{complete ? 'Completed' : 'Add'}</div>
    </div>
  )
}

const AccountChecklistRow = ({ row }) => {
  return (
    <div className={'flex w-full flex-row  items-center justify-between border-b border-solid py-6'}>
      <div className={`paragraph-lg font-bold ${row.complete ? 'text-primary-blue' : 'text-primary-black'}`}>
        {row.title}
      </div>
      <AccountChecklistCompleteButton complete={row.complete} callback={row.callback} />
    </div>
  )
}

export const AccountChecklistStatic = ({ unassignedTransactionItems, isActive, handleToggle, children }) => {
  const { handlePushState } = useAccountLayoutContext()

  const items = useMemo(() => {
    const items = [
      {
        id: 'start-shopping',
        icon: 'bag',
        title: accountTranslations.my_rewards.checklist.shopping.title,
        ctaTitle: accountTranslations.my_rewards.checklist.shopping.cta,
        ctaAction: '/collections/shop-all'
      },
      {
        id: 'assign-shoes',
        icon: 'bag',
        title: `${accountTranslations.my_rewards.checklist.assign_shoes.title}${
          unassignedTransactionItems.items.length > 0
            ? ` You have ${unassignedTransactionItems.items.length} ${
                unassignedTransactionItems.items.length === 1 ? 'shoe' : 'shoes'
              } to assign.`
            : ''
        }`,
        ctaTitle: accountTranslations.my_rewards.checklist.assign_shoes.cta,
        ctaAction: handleToggle,
        disabled: unassignedTransactionItems.items.length < 1
      }
    ]

    if (children.some((child) => child.connector.birth_year === null || child.connector.birth_month === null)) {
      items.push({
        id: 'add-birthday',
        icon: 'Birthday',
        title: accountTranslations.my_rewards.checklist.add_birthday.title,
        ctaTitle: accountTranslations.my_rewards.checklist.add_birthday.cta,
        ctaAction: () => {
          handlePushState('kids-profiles')
        }
      })
    }

    return items
  }, [children])

  return (
    <div>
      <div className={'flex flex-col'}>
        <div className={'flex flex-row justify-between py-6'}>
          <h3 className={'h3 font-bold text-primary-blue'}>{accountTranslations.my_rewards.checklist.title}</h3>
        </div>
        <div>
          {items.map((row) => {
            return (
              <div className={'flex w-full flex-row  items-center justify-between gap-4 border-b border-solid py-6'}>
                <div className={'my-auto flex flex-row gap-2'}>
                  <Icon id={row.icon} className={'min-w-6'} />
                  <div className={'paragraph-lg font-bold text-primary-black'}>{row.title}</div>
                </div>
                {
                  typeof row.ctaAction === 'string' ? (
                    <a href={row.ctaAction} className={'flex h-10 w-10 min-w-10 flex-row items-center justify-center rounded-full border border-solid border-black text-center disabled:opacity-50 md:min-w-32 md:rounded-3xl md:p-2 md:px-4'}>
                      <Icon id={'chevron-right'} className={'inline md:hidden'} />
                      <div className={'paragraph-sm hidden md:inline'}>{row.ctaTitle}</div>
                    </a>
                  ) : (
                    <button
                  onClick={typeof row.ctaAction === 'function' ? row.ctaAction : undefined}
                  disabled={row.disabled}
                  className={
                    'flex h-10 w-10 min-w-10 flex-row items-center justify-center rounded-full border border-solid border-black text-center disabled:opacity-50 md:min-w-32 md:rounded-3xl md:p-2 md:px-4'
                  }
                >
                  <Icon id={'chevron-right'} className={'inline md:hidden'} />
                  <div className={'paragraph-sm hidden md:inline'}>{row.ctaTitle}</div>
                </button>
                  )}
                {row.id === 'assign-shoes' && (
                  <AssignShoesModal
                    childrenProfiles={children}
                    unassignedItems={unassignedTransactionItems.items}
                    isActive={isActive}
                    handleToggle={handleToggle}
                    handleRefetch={() => {
                      window.location.reload()
                    }}
                  />
                )}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export const AccountChecklist = ({ checklist }) => {
  const todoCount = checklist.reduce((acc, row) => {
    if (row.complete) {
      acc += 1
    }
    return acc
  }, 0)
  return (
    <div className={'flex flex-col py-4'}>
      <div className={'flex flex-row justify-between pb-6'}>
        <h3 className={'h3 font-bold text-primary-blue'}>{accountTranslations.dashboard.checklist.title}</h3>
        <div className={'paragraph-lg my-auto'}>
          {todoCount}/{checklist.length} completed
        </div>
      </div>
      <div>
        {checklist.map((row) => {
          return <AccountChecklistRow {...{ row }} />
        })}
      </div>
    </div>
  )
}
